import api from '@/utils/api'
import { buildListQuery } from '@/utils/listQuery'

export default {
    getFilteredStaff(filter, page, size, sort) {
        return api.get(`staff` + buildListQuery({ filter, page, size, sort }))
    },

    // every staff member with their per-season payments (for the match form)
    getAllStaff() {
        return api.get('staff/all')
    },

    getStaff(id) {
        return api.get(`staff/${id}`)
    },

    createStaff(data) {
        return api.post('staff', data)
    },

    updateStaff(id, data) {
        return api.put(`staff/${id}`, data)
    },

    deleteStaff(id) {
        return api.delete(`staff/${id}`)
    }
}
